import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { numberSeparator } from './helpers/formats';

type MarketCode = 'NO' | 'SE';

export interface Market {
  host: string;
  marketCode: MarketCode;
  locale: string;
}

const getLocales = () =>
  process.env.SSR ? (global as any).__WAYKE_LOCALES__ : window.__WAYKE_LOCALES__;

export const getMarket = (): Market =>
  process.env.SSR ? (global as any).__WAYKE_MARKET__ : window.__WAYKE_MARKET__;

const getI18n = (market?: Market) => {
  if (i18n.isInitialized && !process.env.SSR) return i18n;
  i18n.use(initReactI18next).init({
    resources: getLocales(),
    initImmediate: true,
    lng: market?.locale,
    fallbackLng: 'en-US',
    defaultNS: 'common',
    debug: false,
    load: 'currentOnly',
    interpolation: {
      escapeValue: false,
      format: (value, format) => {
        if (format === 'number') {
          // Server uses stripped icu, unable to add full-icu
          //return new Intl.NumberFormat(getMarket().locale).format(value);
          return numberSeparator(value);
        }
        return value;
      },
    },
    react: {
      useSuspense: false,
    },
    ns: [
      'article',
      'assigment',
      'common',
      'customerService',
      'error',
      'finance',
      'footer',
      'global',
      'glossary',
      'guaranteePackage',
      'header',
      'insurance',
      'item',
      'list',
      'listPage',
      'liveshopping',
      'loginModal',
      'navigation',
      'other',
      'profile',
      'retailer',
      'search',
      'startpage',
      'validation',
      'valuation',
      'vehicleProperties',
    ],
  });
  return i18n;
};

export default getI18n;
